import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';
import { rtkAppRetry } from '#store/apiRetry.ts';

export const TAGS = {
    SUBSCRIPTIONS: 'SUBSCRIPTIONS',
};
export const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_APP_NOTIFICATIONS_API,
    prepareHeaders,
});

export const apiNotificationsRoot = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiNotifications',
    baseQuery: rtkAppRetry(customFetchBaseQuery),
    endpoints: () => ({}),
});
